import axios from 'axios';

import { API_URL, DEFAULT_PATHS } from 'config.js';
import { store } from 'store.js';

import { setCaricamentoInCorso, setQualifiche, setCaricamentoSupp, setQualificheSupp, setIdRating } from 'features/80/rating/ratingSlice';

const API_URL_RATING = `${API_URL}/80/get_qualifiche/`;
const API_URL_RATING_SUPP = `${API_URL}/80/get_qualifiche_supp/`;
const API_MODIFICA_URL = `${API_URL}/80/set_dato/`;
const API_GET_DATO_URL = `${API_URL}/generals/get_dato/`;

const startLoading = () => {
  store.dispatch(setCaricamentoInCorso(true));
};

const endLoading = () => {
  store.dispatch(setCaricamentoInCorso(false));
};

const startLoadingSupp = () => {
  store.dispatch(setCaricamentoSupp(true));
};

const endLoadingSupp = () => {
  store.dispatch(setCaricamentoSupp(false));
};

const getCreds = () => {
  const state = store.getState();
  const { auth } = state;
  const { utente, pin } = auth.currentUser;
  return [utente, pin];
};

export const richiediDati = async () => {
  const [utente, pin] = getCreds();

  startLoading();
  const ratings = await axios.post(API_URL_RATING, { utente, pin });
  endLoading();

  const { successo, dati } = ratings;

  if (!successo) return alert('Error while retrieving data');

  return store.dispatch(setQualifiche(dati?.qualifiche ?? []));
};

export const richiediQualificheSupp = async (id) => {
  const [utente, pin] = getCreds();

  startLoading();
  const ratingsSupp = await axios.post(API_URL_RATING_SUPP, { utente, pin, idContratto: id });
  endLoading();

  const { successo, dati } = ratingsSupp.data;

  if (!successo) return alert('Error while retrieving data');

  return store.dispatch(setQualificheSupp(dati?.qualifiche ?? []));
};

export const richiediQualificaSingola = async (idDato) => {
  const [utente, pin] = getCreds();

  const {
    rating80: { idRating },
  } = store.getState();

  const rating = await axios.post(API_GET_DATO_URL, { utente, pin, idContratto: idRating, dato: idDato });

  const { successo, dato } = rating.data;

  if (!successo) return false;

  return dato;
};

const richiediIdRating = async () => {
  const [utente, pin] = getCreds();

  const ratings = await axios.post(API_URL_RATING, { utente, pin });

  const { successo, dati } = ratings.data;

  if (!successo) return false;

  store.dispatch(setIdRating(dati?.qualifiche));

  return dati?.qualifiche;
};

export const bootstrapQualifiche = async () => {
  startLoading();
  const idRating = await richiediIdRating();

  if (!idRating && idRating !== 0) {
    endLoading();
    return alert('Error while retrieving data');
  }

  await richiediQualificheSupp(idRating);

  return endLoading();
};

export const updateDato = async (beforeUpdate, afterUpdate, error, idDato, val, file = 'dato') => {
  beforeUpdate();

  const [utente, pin] = getCreds();
  const {
    rating80: { idRating },
  } = store.getState();

  const valore = file === 'file' ? val.slice(28) : val;

  const res = await axios.post(API_MODIFICA_URL, { utente, pin, idContratto: idRating, idDato, valore, tipofile: file, tipo: 'rating' });

  const { successo, errore } = res.data;

  if (!successo) {
    error();
    return alert(errore);
  }

  return afterUpdate();
};
